import { useState } from 'react'
import { STORAGE_KEYS } from '../constants'

export const useLocalStorage = (key, initialValue) => {
  // Get from local storage then parse stored json or return initialValue
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error)
      return initialValue
    }
  })

  // Return a wrapped version of useState's setter function that persists the new value to localStorage
  const setValue = value => {
    try {
      // Allow value to be a function so we have the same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value
      setStoredValue(valueToStore)

      try {
        window.localStorage.setItem(key, JSON.stringify(valueToStore))
      } catch (storageError) {
        // localStorage.setItem может fail в инкогнито или при переполнении quota
        console.warn(`localStorage.setItem failed for key "${key}":`, storageError)
        // Продолжаем работу с in-memory state
      }
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error)
    }
  }

  return [storedValue, setValue]
}

export const useQuizSelections = path => {
  return useLocalStorage(
    path.includes('/create-ai-hentai') ? STORAGE_KEYS.AI_GIRLFRIEND_SELECTIONS_HENTAI : STORAGE_KEYS.AI_GIRLFRIEND_SELECTIONS,
    {},
  )
}

export const useTrackingParams = () => {
  return useLocalStorage(STORAGE_KEYS.TRACKING_PARAMS, {})
}
